var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    staticClass: "px-3 mx-n3",
    attrs: {
      "max-width": "1080",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('list-heading', {
    attrs: {
      "title": "브릿지 프로그램 목록",
      "showsFilterButton": ""
    },
    model: {
      value: _vm.showsSearch,
      callback: function ($$v) {
        _vm.showsSearch = $$v;
      },
      expression: "showsSearch"
    }
  }), _c('expo-program-list-search', _vm._b({}, 'expo-program-list-search', {
    showsSearch: _vm.showsSearch
  }, false)), _c('v-data-table', _vm._b({
    staticClass: "v-sheet--outlined",
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "disable-sort": "",
      "disable-pagination": "",
      "hide-default-footer": "",
      "items-per-page": -1
    },
    scopedSlots: _vm._u([_vm._l(_vm.headers.filter(function (header) {
      return header.hasOwnProperty('formatter');
    }), function (header) {
      return {
        key: `item.${header.value}`,
        fn: function (_ref) {
          var value = _ref.value;
          return [_vm._v(" " + _vm._s(header.formatter(value)) + " ")];
        }
      };
    }), {
      key: `item.host`,
      fn: function (_ref2) {
        var _value$user, _value$user2;
        var value = _ref2.value;
        return [_c('span', [_vm._v(" " + _vm._s(((_value$user = value.user) === null || _value$user === void 0 ? void 0 : _value$user.name) || "-") + " (" + _vm._s(((_value$user2 = value.user) === null || _value$user2 === void 0 ? void 0 : _value$user2.username) || "-") + ") ")])];
      }
    }, {
      key: `item.subject`,
      fn: function (_ref3) {
        var _item$thumb, _item$host;
        var item = _ref3.item,
          value = _ref3.value;
        return [_c('v-list-item', {
          attrs: {
            "href": `/programs/${item._id}`
          }
        }, [_c('v-list-item-avatar', {
          attrs: {
            "color": "grey lighten-3",
            "rounded": "",
            "size": "64"
          }
        }, [_c('v-img', {
          staticClass: "v-sheet--outlined",
          attrs: {
            "src": item === null || item === void 0 ? void 0 : (_item$thumb = item.thumb) === null || _item$thumb === void 0 ? void 0 : _item$thumb.src
          },
          scopedSlots: _vm._u([{
            key: "placeholder",
            fn: function () {
              return [_c('v-icon', [_vm._v("mdi-image-broken-variant")])];
            },
            proxy: true
          }], null, true)
        })], 1), _c('v-list-item-content', [_c('v-list-item-subtitle', {
          staticClass: "text-truncate"
        }, [_vm._v(" " + _vm._s((_item$host = item.host) === null || _item$host === void 0 ? void 0 : _item$host.name) + " ")]), _c('v-list-item-title', {
          staticClass: "text-truncate"
        }, [_vm._v(" " + _vm._s(value) + " ")]), _c('p', {
          staticClass: "mt-2 mb-0 text-truncate"
        }, [_vm._v(_vm._s(item.summary))])], 1)], 1)];
      }
    }, {
      key: `item.isGranted`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('v-switch', _vm._b({
          staticClass: "ml-n2",
          on: {
            "change": function (isGranted) {
              return _vm.update({
                _id: item._id,
                isGranted
              });
            }
          },
          model: {
            value: item.isGranted,
            callback: function ($$v) {
              _vm.$set(item, "isGranted", $$v);
            },
            expression: "item.isGranted"
          }
        }, 'v-switch', _vm.attrs_switch__console, false))];
      }
    }, {
      key: `item.actions`,
      fn: function (_ref5) {
        var item = _ref5.item;
        return [_c('v-btn', {
          attrs: {
            "small": "",
            "text": "",
            "icon": "",
            "tile": "",
            "to": `/console/expo/programs/${item._id}`
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v(" mdi-eye ")])], 1)];
      }
    }], null, true)
  }, 'v-data-table', {
    loading: _vm.loading,
    headers: _vm.headers,
    items: _vm.items
  }, false)), _c('v-pagination', {
    staticClass: "mt-2",
    attrs: {
      "value": _vm.page,
      "length": _vm.pageCount,
      "total-visible": 11,
      "color": "primary"
    },
    on: {
      "input": function (page) {
        return _vm.$router.push({
          query: Object.assign({}, _vm.$route.query, {
            page
          })
        });
      }
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }